import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TrainersResult } from "../models/trainers";

@Injectable({
  providedIn: 'root'
})
export class TrainersService {

  constructor(
    private http: HttpClient
  ) {
  }

  public getTrainers(): Observable<TrainersResult> {
    return this.http.get<TrainersResult>('https://s3.eu-west-1.amazonaws.com/com.elite.repository/assets/trainers/trainers.json')
  }
}
